export enum SchemeEcmType {
  GMA = 1,
  RP = 2,
}
